<div *ngIf="show" class="loader card">
    <div class="loader-overlay">
        <div class="spinner-bubble spinner-bubble-warning m-5"></div>
    </div>
</div>